import { render } from "./BaseAttachmentPreview.vue?vue&type=template&id=fef591a8&scoped=true"
import script from "./BaseAttachmentPreview.vue?vue&type=script&lang=js"
export * from "./BaseAttachmentPreview.vue?vue&type=script&lang=js"

import "./BaseAttachmentPreview.vue?vue&type=style&index=0&id=fef591a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fef591a8"]])

export default __exports__